export enum TaskTypes {
  OPENED = 'opened',
  COMPLETED = 'completed'
}

export interface Widget {
  widget_type: string
  title: string
  redirect_url: string
}

export interface WidgetFunctionProps<T extends Widget> {
  instance: T
}

export interface ChartWidget extends Widget {
  chart: string[][]
}

export interface User {
  sso_id: string
  email: string
  first_name: string
  last_name: string
}

export interface Task {
  id: string
  title: string
  created_by: User
  created_at: string
  users: User[]
}

export interface TaskListWidget extends Widget {
  completed: Task[]
  opened: Task[]
}

export interface MediaWidget extends Widget {
  media_type: 'video' | 'default'
  from: string
  media_url: string
}
